export const escalationReviewOptions = [
  { value: 'missing-debt-service-coverage-ratio', label: 'Missing DSCR Review' },
  { value: 'debt-service-coverage-ratio', label: 'DSCR Review' },
  { value: 'mortgage-late', label: 'Mtg Late Review' },
  { value: 'credit-score', label: 'FICO Review' },
  { value: 'third-lien', label: '3rd Lien Review' },
  { value: 'investment-size', label: 'Inv Size Review' },
  { value: 'bankruptcy', label: 'BK Review' },
  { value: 'total-home-finance', label: 'THF Review' },
  { value: 'property-atypicality', label: 'Atypicality Review' },
  { value: 'home-value', label: 'Home Value Review' },
  { value: 'exotic-mortgage', label: 'IO/Neg Am Review' },
  { value: 'foreclosure', label: 'FC Review' },
  { value: 'short-sale', label: 'SS Review' },
  { value: 'deed-in-lieu', label: 'DIL Review' },
  { value: 'property-condition', label: 'Property Condition Review' },
  { value: 'title-report-review', label: 'Title Report Review' },
  { value: 'appraisal-report-review', label: 'Appraisal Report Review' },
  { value: 'manager-review', label: 'Manager Review' },
  { value: 'avm-not-available', label: 'AVM Not Available Review' },
  { value: 'loe', label: 'LOE Review' },
  { value: 'forbearance', label: 'FB Review' },
  { value: 'lot-size', label: 'Lot Size Review' },
  { value: 'property-type', label: 'Property Type Review' },
  { value: 'roof-solar-panel', label: 'Solar Review' },
  { value: 'flag-home-value', label: 'Home Value Review' },
  { value: 'avm-variance-check', label: 'SV Variance Review' },
]

export const escalationFlagsTypes = [
  'property-atypicality',
  'missing-debt-service-coverage-ratio',
  'missing-dti',
  'flag-home-value',
  'property-type',
  'roof-solar-panel',
  'lot-size',
  'avm-variance-check',
]
